import React from 'react';

const AI = () => {
  return (
    <div style={{
      minHeight: '60vh',
      background: 'linear-gradient(135deg, #f3e8ff 0%, #dbeafe 100%)',
      padding: '2rem 1rem',
    }}>
      <div className="page-wrapper">
        <div className="page-hero">
          <h1>🧠 AI & Machine Learning</h1>
          <p>Explore the latest in artificial intelligence and machine learning.</p>
        </div>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '2rem',
        }}>
          <p>AI content will be rendered here</p>
        </div>
      </div>
    </div>
  );
};

export default AI;
